import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
@Component({
  selector: "view-pdf-dialog",
  template: `
  <div>
  <div [innerHTML]="pdfUrl">
  </div>
  <div>
  <button mat-button (click)="this.dialogRef.close()" mat-raised-button style="float:right">
  Close
  </button>
  </div></div>`
})
export class ViewPdfDialogComponent implements OnInit {
  pdfUrl: SafeUrl;
  isLoading = true;
  constructor(public dialogRef: MatDialogRef<ViewPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer) {
    const datasource = '<embed src="' + data.pdfUrl + '" style = "width:100%;height:480px" type = "application/pdf"> ';
    this.pdfUrl = this.sanitizer.bypassSecurityTrustHtml(datasource);
  }

  async ngOnInit() {
    this.isLoading = false
  }
}

